import { memo } from 'react';
import PropTypes from 'prop-types';
import readTourNotesText from '../../../../../helpers/readTourNotesText';

export const hasOperatorDetails = (itinerary) => {
  const operator = itinerary?.operatorInfo;
  if (!operator) {
    return false;
  }
  return !!(
    operator.name ||
    operator.phone ||
    operator.email ||
    operator.pickupTime ||
    readTourNotesText(operator.notes)
  );
};

const OperatorDetails = ({ itinerary }) => {
  const operator = itinerary.operatorInfo || {};
  const notesText = readTourNotesText(operator.notes);

  return (
    <div className="text-sm">
      <div className="grid grid-cols-2 gap-1 md:w-2/3">
        {operator.name && (
          <>
            <div>Operator:</div>
            <div>{operator.name}</div>
          </>
        )}
        {operator.phone && (
          <>
            <div>Phone:</div>
            <div>{operator.phone}</div>
          </>
        )}
        {operator.email && (
          <>
            <div>Email:</div>
            <div>{operator.email}</div>
          </>
        )}
        {operator.pickupTime && (
          <>
            <div>Pickup time:</div>
            <div>{operator.pickupTime}</div>
          </>
        )}
      </div>
      {notesText && <div className="mt-3 whitespace-pre-line">{notesText}</div>}
    </div>
  );
};

OperatorDetails.propTypes = {
  itinerary: PropTypes.shape().isRequired,
};

export default memo(OperatorDetails);
